export interface Movie {
  id: string;
  title: string;
  englishTitle: string;
  year: number;
  rating: number;
  quality: string;
  category: string;
  categorySlug: string;
  genre: string[];
  duration: string;
  description: string;
  longDescription: string;
  director: string;
  actors: string[];
  poster: string;
  backdrop: string;
  trailerUrl: string;
  releaseDate: string;
  region: string;
  isHot: boolean;
  isNew: boolean;
  views: number;
  episodeTotal?: number;
  episodeCurrent?: number;
}

export const categories = [
  { name: '全部', slug: 'all', icon: 'ri-grid-line' },
  { name: '电影', slug: 'movie', icon: 'ri-film-line' },
  { name: '电视剧', slug: 'drama', icon: 'ri-tv-line' },
  { name: '动漫', slug: 'anime', icon: 'ri-rocket-line' },
  { name: '综艺', slug: 'variety', icon: 'ri-music-line' },
  { name: '纪录片', slug: 'documentary', icon: 'ri-camera-line' },
];

export const movies: Movie[] = [
  {
    id: '1',
    title: '流浪地球3',
    englishTitle: 'The Wandering Earth 3',
    year: 2026,
    rating: 9.2,
    quality: '4K',
    category: '电影',
    categorySlug: 'movie',
    genre: ['科幻', '冒险', '灾难'],
    duration: '148分钟',
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对未知的宇宙之旅，年轻一代挺身而出，展开一场跨越时空的生死救援。',
    longDescription: '在《流浪地球3》中，地球在宇宙中航行的旅程进入了全新的阶段。随着太阳系边界的临近，人类面临着前所未有的挑战。联合政府与叛军之间的冲突不断升级，而更令人担忧的是，在宇宙深处出现的未知文明信号，让人类的未来充满了变数。刘培强等新一代航天员将肩负起保护地球和人类文明的重任。',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '沙溢', '王智'],
    poster: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20sci-fi%20movie%20poster%20with%20astronauts%20and%20massive%20planet%20engines%20in%20deep%20space%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20dark%20and%20warm%20orange%20tones%2C%20high%20quality%20render&width=600&height=900&seq=movie-poster-01&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Epic%20cinematic%20space%20scene%20with%20Earth%20and%20massive%20engines%20traveling%20through%20galaxy%2C%20dramatic%20orange%20and%20dark%20blue%20lighting%2C%20high%20contrast%2C%20cinematic%20atmosphere&width=1920&height=800&seq=movie-bg-01&orientation=landscape',
    trailerUrl: '#',
    releaseDate: '2026-01-22',
    region: '中国大陆',
    isHot: true,
    isNew: true,
    views: 12800000,
  },
  {
    id: '2',
    title: '哪吒之魔童闹海',
    englishTitle: 'Ne Zha 2',
    year: 2025,
    rating: 9.5,
    quality: '4K',
    category: '电影',
    categorySlug: 'movie',
    genre: ['动画', '奇幻', '冒险'],
    duration: '126分钟',
    description: '天劫之后，哪吒与敖丙的灵魂虽被保住，但肉身却危在旦夕。太乙真人打算用七色宝莲为二人重塑肉身，但在此过程中却遭遇重重困难。',
    longDescription: '经历了天劫的哪吒和敖丙，灵魂虽然保住了，但他们的肉身却岌岌可危。太乙真人决定用七色宝莲为他们重塑肉身，然而这个过程充满了未知的挑战。与此同时，一股来自深海的神秘力量正在蠢蠢欲动，一个更大的阴谋正在浮出水面。哪吒能否渡过难关，揭开真相？',
    director: '饺子',
    actors: ['吕艳婷', '囧森瑟夫', '瀚墨', '陈浩'],
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20fantasy%20movie%20poster%20featuring%20mythological%20boy%20warrior%20with%20fire%20and%20dragon%2C%20vibrant%20red%20and%20gold%20colors%2C%20dynamic%20action%20pose%2C%20cinematic%20lighting&width=600&height=900&seq=movie-poster-02&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythological%20animated%20scene%20with%20fire%20and%20water%20elements%20clashing%2C%20dramatic%20red%20and%20blue%20color%20contrast%2C%20cinematic%20composition&width=1920&height=800&seq=movie-bg-02&orientation=landscape',
    trailerUrl: '#',
    releaseDate: '2025-01-29',
    region: '中国大陆',
    isHot: true,
    isNew: false,
    views: 25600000,
  },
  {
    id: '3',
    title: '封神第二部：战火西岐',
    englishTitle: 'Creation of the Gods II',
    year: 2025,
    rating: 8.8,
    quality: '4K',
    category: '电影',
    categorySlug: 'movie',
    genre: ['奇幻', '动作', '史诗'],
    duration: '155分钟',
    description: '西岐战争全面爆发，姜子牙率领众神迎战。纣王派遣大军压境，一场关乎天下苍生的大战拉开帷幕。',
    longDescription: '纣王的暴虐统治让天下生灵涂炭。姜子牙携封神榜下山，辅佐武王伐纣。西岐之战全面爆发，各路神仙妖魔纷纷登场，一场惊天动地的大战就此展开。在这场战争中，每个人都将面临命运的抉择。',
    director: '乌尔善',
    actors: ['费翔', '李雪健', '黄渤', '于适'],
    poster: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20war%20movie%20poster%20with%20ancient%20warriors%20and%20mythological%20creatures%2C%20dramatic%20battle%20scene%2C%20gold%20and%20dark%20tones&width=600&height=900&seq=movie-poster-03&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20battlefield%20with%20thousands%20of%20warriors%20and%20mythological%20beasts%2C%20epic%20scale%2C%20dramatic%20sky%2C%20cinematic%20photography&width=1920&height=800&seq=movie-bg-03&orientation=landscape',
    trailerUrl: '#',
    releaseDate: '2025-07-26',
    region: '中国大陆',
    isHot: true,
    isNew: true,
    views: 18900000,
  },
  {
    id: '4',
    title: '庆余年 第二季',
    englishTitle: 'Joy of Life Season 2',
    year: 2024,
    rating: 9.1,
    quality: '4K',
    category: '电视剧',
    categorySlug: 'drama',
    genre: ['古装', '权谋', '喜剧'],
    duration: '45分钟/集',
    description: '范闲从北齐归来后，发现自己已深陷皇子之间的权谋争斗。在京都的暗流涌动中，他必须用智慧和勇气保护自己和身边的人。',
    longDescription: '范闲从北齐归来后，发现京都的局势早已物是人非。皇家内部的权力斗争愈演愈烈，而他作为庆帝的私生子，更是被推到了风口浪尖。面对二皇子的步步紧逼，范闲必须小心周旋。同时，监察院的秘密、母亲叶轻眉的往事也逐渐浮出水面。',
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明', '吴刚', '郭麒麟'],
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%20with%20elegant%20costume%20characters%20in%20ancient%20palace%2C%20warm%20golden%20lighting%2C%20luxurious%20textures%2C%20cinematic%20portrait&width=600&height=900&seq=movie-poster-04&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20palace%20interior%20with%20warm%20candlelight%20and%20rich%20decoration%2C%20dramatic%20shadows%2C%20cinematic%20atmosphere&width=1920&height=800&seq=movie-bg-04&orientation=landscape',
    trailerUrl: '#',
    releaseDate: '2024-05-16',
    region: '中国大陆',
    isHot: false,
    isNew: false,
    views: 45200000,
    episodeTotal: 36,
    episodeCurrent: 36,
  },
  {
    id: '5',
    title: '三体',
    englishTitle: 'Three-Body',
    year: 2023,
    rating: 8.8,
    quality: '4K',
    category: '电视剧',
    categorySlug: 'drama',
    genre: ['科幻', '悬疑', '剧情'],
    duration: '55分钟/集',
    description: '纳米科学家汪淼被卷入一场神秘事件，逐步揭开了地球基础科学研究受到异常干扰的真相，以及一个来自三体文明的神秘计划。',
    longDescription: '2007年，地球基础科学出现了异常的扰动。纳米科学家汪淼被警官史强带入了一个神秘的组织"科学边界"，从而卷入了一场揭开神秘力量真相的斗争。随着调查深入，他发现了三体文明与地球之间的秘密联系，以及一场跨越数百年的宏大计划。',
    director: '杨磊',
    actors: ['张鲁一', '于和伟', '陈瑾', '王子文'],
    poster: 'https://readdy.ai/api/search-image?query=Mysterious%20sci-fi%20drama%20poster%20with%20cosmic%20elements%20and%20scientists%2C%20dark%20atmosphere%20with%20red%20accents%2C%20cinematic%20composition&width=600&height=900&seq=movie-poster-05&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cosmic%20universe%20with%20three%20suns%20and%20mysterious%20civilization%2C%20dark%20space%20atmosphere%2C%20scientific%20equipment%20silhouette%2C%20cinematic&width=1920&height=800&seq=movie-bg-05&orientation=landscape',
    trailerUrl: '#',
    releaseDate: '2023-01-15',
    region: '中国大陆',
    isHot: false,
    isNew: false,
    views: 38900000,
    episodeTotal: 30,
    episodeCurrent: 30,
  },
  {
    id: '6',
    title: '间谍过家家',
    englishTitle: 'SPY x FAMILY',
    year: 2024,
    rating: 9.3,
    quality: '4K',
    category: '动漫',
    categorySlug: 'anime',
    genre: ['喜剧', '动作', '日常'],
    duration: '24分钟/集',
    description: '为了执行秘密任务，西国间谍"黄昏"必须组建一个家庭。他收养了能读心的女儿阿尼亚，并与杀手约尔假结婚，一个奇妙的家庭就此诞生。',
    longDescription: '顶尖间谍"黄昏"接到了一项终极任务——接近东国的重要政治人物。为此，他必须在七天内组建一个家庭，把"孩子"送入名校。他收养了拥有读心能力的少女阿尼亚，又与秘密杀手约尔假结婚。三个各怀秘密的人组成的临时家庭，在爆笑与温情中开始了他们的日常生活。',
    director: '古桥一浩',
    actors: ['江口拓也', '种崎敦美', '早见沙织'],
    poster: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20family%20comedy%20poster%20with%20spy%20themed%20characters%2C%20warm%20and%20playful%20tone%2C%20clean%20illustration%20style&width=600&height=900&seq=movie-poster-06&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Stylish%20anime%20cityscape%20with%20warm%20sunset%20lighting%2C%20elegant%20European%20architecture%2C%20whimsical%20and%20cozy%20atmosphere&width=1920&height=800&seq=movie-bg-06&orientation=landscape',
    trailerUrl: '#',
    releaseDate: '2024-10-07',
    region: '日本',
    isHot: false,
    isNew: true,
    views: 15600000,
    episodeTotal: 25,
    episodeCurrent: 18,
  },
  {
    id: '7',
    title: '长安十二时辰',
    englishTitle: 'The Longest Day in Chang\'an',
    year: 2019,
    rating: 9.0,
    quality: '超清',
    category: '电视剧',
    categorySlug: 'drama',
    genre: ['古装', '悬疑', '动作'],
    duration: '45分钟/集',
    description: '唐朝上元节前夕，长安城陷入了一场巨大的危机。死囚张小敬临危受命，与少年名士李必携手在十二时辰内拯救长安。',
    longDescription: '天宝三载，上元节前夕。长安城内暗流涌动，突厥狼卫渗透入城，试图在节日当天制造混乱。死囚张小敬被靖安司司丞李必从死牢中提出，要求在十二时辰内追查狼卫，拯救长安。一场与时间赛跑的惊心动魄就此展开。',
    director: '曹盾',
    actors: ['雷佳音', '易烊千玺', '周一围', '热依扎'],
    poster: 'https://readdy.ai/api/search-image?query=Tang%20Dynasty%20Chinese%20historical%20thriller%20poster%20with%20ancient%20city%20and%20warriors%2C%20dramatic%20lighting%2C%20rich%20dark%20red%20and%20gold%20tones&width=600&height=900&seq=movie-poster-07&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Ancient%20Tang%20Dynasty%20Chinese%20capital%20city%20at%20night%20with%20lanterns%20and%20crowds%2C%20bustling%20atmosphere%2C%20cinematic%20wide%20shot&width=1920&height=800&seq=movie-bg-07&orientation=landscape',
    trailerUrl: '#',
    releaseDate: '2019-06-27',
    region: '中国大陆',
    isHot: false,
    isNew: false,
    views: 32000000,
    episodeTotal: 48,
    episodeCurrent: 48,
  },
  {
    id: '8',
    title: '鬼灭之刃 柱训练篇',
    englishTitle: 'Demon Slayer: Hashira Training',
    year: 2024,
    rating: 9.1,
    quality: '4K',
    category: '动漫',
    categorySlug: 'anime',
    genre: ['动作', '奇幻', '热血'],
    duration: '24分钟/集',
    description: '在经历了锻刀村篇的激战后，炭治郎等人开始了严格的柱训练。在各位柱的指导下，他们为即将到来的最终决战做准备。',
    longDescription: '经过锻刀村的激战后，炭治郎和他的伙伴们迎来了新的挑战——柱训练。在每一位柱的悉心指导下，他们不断突破自己的极限，磨练技艺。这不仅仅是对身体的训练，更是对意志的考验。而在这场训练背后，鬼舞辻无惨的阴影正在逼近。',
    director: '外崎春雄',
    actors: ['花江夏树', '鬼头明里', '下野纮'],
    poster: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20action%20poster%20with%20demon%20slayer%20characters%20training%2C%20dynamic%20pose%2C%20vibrant%20water%20and%20fire%20effects&width=600&height=900&seq=movie-poster-08&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20mountainside%20training%20grounds%20with%20cherry%20blossoms%2C%20misty%20atmosphere%2C%20serene%20but%20intense&width=1920&height=800&seq=movie-bg-08&orientation=landscape',
    trailerUrl: '#',
    releaseDate: '2024-05-12',
    region: '日本',
    isHot: true,
    isNew: true,
    views: 9800000,
    episodeTotal: 8,
    episodeCurrent: 6,
  },
  {
    id: '9',
    title: '蓝色星球3',
    englishTitle: 'Blue Planet III',
    year: 2025,
    rating: 9.7,
    quality: '4K',
    category: '纪录片',
    categorySlug: 'documentary',
    genre: ['自然', '海洋', '探索'],
    duration: '50分钟/集',
    description: '深入探索全球海洋的每一个角落，从极地冰海到热带珊瑚礁，揭开深海中前所未见的生物奥秘。',
    longDescription: '《蓝色星球3》带领观众踏上前所未有的海洋探索之旅。从南极的冰下世界到太平洋最深的海沟，从色彩缤纷的珊瑚礁到充满未知的深海热泉，每一集都展示了令人叹为观止的海洋奇观和令人惊叹的新发现。使用最新的深海拍摄技术，捕捉到了许多此前从未被记录过的海洋生物行为。',
    director: '詹姆斯·霍尼伯内',
    actors: ['大卫·爱登堡'],
    poster: 'https://readdy.ai/api/search-image?query=Stunning%20ocean%20documentary%20poster%20with%20deep%20blue%20sea%20creatures%20and%20coral%20reef%2C%20majestic%20marine%20life%2C%20professional%20photography&width=600&height=900&seq=movie-poster-09&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Magnificent%20underwater%20ocean%20scene%20with%20sunlight%20rays%20penetrating%20deep%20blue%20water%2C%20whale%20and%20dolphins%2C%20breathtaking%20nature&width=1920&height=800&seq=movie-bg-09&orientation=landscape',
    trailerUrl: '#',
    releaseDate: '2025-03-15',
    region: '英国',
    isHot: false,
    isNew: true,
    views: 7500000,
    episodeTotal: 8,
    episodeCurrent: 8,
  },
  {
    id: '10',
    title: '奔跑吧 第八季',
    englishTitle: 'Keep Running S8',
    year: 2024,
    rating: 8.2,
    quality: '超清',
    category: '综艺',
    categorySlug: 'variety',
    genre: ['真人秀', '竞技', '搞笑'],
    duration: '90分钟/期',
    description: '兄弟团再次集结，踏上全新的奔跑之旅。本季将前往更多令人惊叹的目的地，挑战更多出人意料的游戏。',
    longDescription: '《奔跑吧》第八季重磅回归！兄弟团成员再度集结，开启全新一季的奔跑旅程。本季节目将走遍祖国的大江南北，从冰天雪地的北国到热情似火的南方，从历史悠久的古城到现代化的都市。全新设计的游戏环节、更加激烈的撕名牌大战，以及让人捧腹大笑的欢乐时刻，都将为观众带来前所未有的娱乐体验。',
    director: '姚译添',
    actors: ['李晨', '郑恺', '沙溢', '白鹿', '周深'],
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20energetic%20cast%20running%20and%20laughing%2C%20bright%20and%20colorful%20design%2C%20fun%20atmosphere&width=600&height=900&seq=movie-poster-10&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Colorful%20outdoor%20adventure%20park%20with%20obstacle%20courses%2C%20sunny%20day%2C%20energetic%20and%20fun%20atmosphere&width=1920&height=800&seq=movie-bg-10&orientation=landscape',
    trailerUrl: '#',
    releaseDate: '2024-04-26',
    region: '中国大陆',
    isHot: false,
    isNew: false,
    views: 22000000,
    episodeTotal: 12,
    episodeCurrent: 8,
  },
  {
    id: '11',
    title: '热辣滚烫',
    englishTitle: 'YOLO',
    year: 2024,
    rating: 8.5,
    quality: '4K',
    category: '电影',
    categorySlug: 'movie',
    genre: ['喜剧', '运动', '励志'],
    duration: '129分钟',
    description: '乐莹是一个善良但一直宅在家中的女孩。在经历了一系列挫折后，她决定通过拳击改变自己的人生，开启了热辣滚烫的新篇章。',
    longDescription: '乐莹毕业后一直宅在家中，与外界隔绝。一次偶然的机会，她接触到了拳击运动。起初只是为了减肥，但在训练的过程中，她逐渐找回了自信和对生活的热爱。通过不懈的努力和坚持，乐莹从一个自卑内向的女孩，蜕变成了一个充满力量的拳击手，也在这个过程中找到了真正的自我。',
    director: '贾玲',
    actors: ['贾玲', '雷佳音', '张小斐', '杨紫'],
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20boxing%20movie%20poster%20with%20female%20boxer%2C%20warm%20and%20inspiring%20tone%2C%20red%20boxing%20gloves%2C%20cinematic%20lighting&width=600&height=900&seq=movie-poster-11&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Boxing%20gym%20with%20dramatic%20lighting%2C%20warm%20atmosphere%2C%20inspiring%20and%20motivational%20vibe%2C%20cinematic&width=1920&height=800&seq=movie-bg-11&orientation=landscape',
    trailerUrl: '#',
    releaseDate: '2024-02-10',
    region: '中国大陆',
    isHot: false,
    isNew: false,
    views: 31000000,
  },
  {
    id: '12',
    title: '唐诡2：西行',
    englishTitle: 'Detective Dee S2',
    year: 2024,
    rating: 8.9,
    quality: '4K',
    category: '电视剧',
    categorySlug: 'drama',
    genre: ['悬疑', '古装', '探案'],
    duration: '45分钟/集',
    description: '狄仁杰奉命西行查案，一路遭遇离奇古怪的案件。在与各路高手的交锋中，他运用超凡智慧揭开一个个惊天谜团。',
    longDescription: '大周年间，狄仁杰奉旨西行查办要案。从繁华的长安到西域边陲，一路上怪事频发：会说话的骷髅、消失的商队、神秘的地下宫殿……每一个案件都看似荒诞不经，背后却暗藏玄机。狄仁杰凭借其超凡的推理能力和敏锐的洞察力，拨开层层迷雾，揭开真相。',
    director: '柏杉',
    actors: ['杨旭文', '杨志刚', '郜思雯', '孙雪宁'],
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20detective%20mystery%20drama%20poster%20with%20ancient%20detective%20in%20dark%20alley%2C%20mysterious%20atmosphere%2C%20warm%20lantern%20light&width=600&height=900&seq=movie-poster-12&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20western%20frontier%20town%20at%20dusk%20with%20caravans%20and%20dust%2C%20mysterious%20atmosphere%2C%20cinematic%20western%20style&width=1920&height=800&seq=movie-bg-12&orientation=landscape',
    trailerUrl: '#',
    releaseDate: '2024-07-18',
    region: '中国大陆',
    isHot: true,
    isNew: true,
    views: 14500000,
    episodeTotal: 36,
    episodeCurrent: 24,
  },
];